import { useMemo } from "react";
import apiClient from "./apiClient";

export interface RequestThumbnailsResult {
  queued: number;
  requested: number;
}

export const useThumbnailApi = () => {
  return useMemo(
    () => ({
      // Ask the backend to (re)generate thumbnails for a batch of images the UMS
      // saw missing. `imageUrls` are the ORIGINAL image URLs (the carousel `src`,
      // NOT the `_thumbnail` ones). The dispatcher fans them out onto an SQS queue
      // (one worker per image); generation is async, so this returns immediately
      // and the thumbnails appear on a later load.
      requestThumbnailsApi: async (
        imageUrls: string[]
      ): Promise<RequestThumbnailsResult> => {
        const { data } = await apiClient.post(`/thumbnails`, { imageUrls });
        return data as RequestThumbnailsResult;
      },
    }),
    []
  );
};
